import React from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from '@/components/Modal'
import { BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { NotEnoughFundsModalProps } from './types'

export const NotEnoughFundsModal: React.FC<NotEnoughFundsModalProps> = ({
  isOpen,
  onClose,
  onAddMoney,
}) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose} snapPoints={['48%']} title="">
      <BaseView
        flex={1}
        px={12}
        py={32}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {/* Content */}
        <BaseView center gap={16}>
          <BaseText
            fontSize={24}
            fontFamily="bold"
            color="#FFFFFF"
            textAlign="center"
          >
            {t('translation:notEnoughFundsModal.oops', 'Oops!')}
          </BaseText>

          <BaseText
            fontSize={16}
            fontFamily="regular"
            color="#FFFFFF"
            textAlign="center"
            style={{
              lineHeight: '22px',
              paddingLeft: '8px',
              paddingRight: '8px',
              opacity: 0.7,
            }}
          >
            {t(
              'notEnoughFunds',
              "It looks like there are not enough funds for withdrawal. Please top up your balance, and then you'll be able to withdraw the money.",
            )}
          </BaseText>
        </BaseView>
        <div style={{ height: 60 }} />
        {/* Actions */}
        <BaseView>
          <AppButton
            label={t('form:actions.addMoney', 'Add money')}
            onPress={onAddMoney}
            style={{
              borderRadius: '16px',
            }}
          />
        </BaseView>
        <div style={{ height: 10 }} />
      </BaseView>
    </Modal>
  )
}
